import {
  getAuth,
  signOut,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
} from "firebase/auth";
import { toast } from "react-toastify";
import {
  getFirestore,
  collection,
  addDoc,
  setDoc,
  doc,
  getDoc,
  updateDoc,
  query,
  where,
  getDocs,
  limit,
  getCountFromServer,
  count,
} from "firebase/firestore";
import { deleteToken, getMessaging } from "firebase/messaging";
import { Timestamp } from "firebase/firestore";
import { Firebase } from "../FirebaseApp";
import Storage from "../helpers/Storage";
import { FireHelper } from "../helpers/FireHelper";
import { DateHelper } from "../helpers/DateHelper";
import { getFunctions, httpsCallable } from "firebase/functions";

export const AccountController = {
  db: getFirestore(Firebase),
  auth: getAuth(Firebase),
  functions: getFunctions(Firebase),

  ToFirestoreUser: function (data) {
    let updatedData = {
      uid: data.uid,
      name: data.name,
      email: data.email,
      display_name: data.display_name,
      document_number: data.document_number,
      phone_number: data.phone_number,
      role: data.role,
      status: data.status ?? "Active",
      created_time: data.created_time ?? Timestamp.now(),
      updated_time: Timestamp.now(),
    };
    return FireHelper.ToFirestoreDoc(updatedData);
  },

  CreateUser: async function (data, res) {
    await createUserWithEmailAndPassword(this.auth, data.email, data.password)
      .then(async (userCredential) => {
        try {
          const user = userCredential.user;
          console.log("Tentou criar", user, userCredential);
          const docRef = doc(this.db, "users", user.uid);

          
          await setDoc(docRef, {
            ...this.ToFirestoreUser(data),
            uid: user.uid,
          }, { merge: true });

          this.Login(data, true);
          res(docRef.id);

        } catch (e) {
          console.error("Error adding document: ", e);
        //   toast.error(AuthError.HandleMessage(e.message));
        }
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.error("Error creating user: ", errorMessage, errorCode, error);
        // toast.error(AuthErrorHelper.HandleMessage(errorMessage));
      });
  },

  Recover: async function (email) {
    try {
      await sendPasswordResetEmail(this.auth, email);
      toast.success("Email de recuperação de senha enviado com sucesso!");
    } catch (error) {
      toast.error("Erro ao enviar email de recuperação de senha: " + error.message);
    }
  },

  Login: async function (data, intern) {
    signInWithEmailAndPassword(this.auth, data.email, data.password)
      .then(async (userCredential) => {
        const user = userCredential.user;

        const userData = await this.GetUser(user.uid);

        Storage.setUserData({ ...user, ...userData });
          this.UpdateToken();

                toast.success("Bem vindo!");
                setTimeout(() => {
                  window.location = "#/app";
                }, 300);
        
        // Update last access date
        const userRef = doc(this.db, "users", user.uid);
        await setDoc(userRef, {
          ...this.ToFirestoreUser(userData),
          uid: user.uid,
        }, { merge: true });
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log("Erro está no login?")
        // toast.error(AuthErrorHelper.HandleMessage(errorMessage), {
        //   autoClose: 15000,
        // });
      });
  },

  Logout: async function () {
    signOut(this.auth);
    deleteToken(getMessaging());
    Storage.deleteUserData();
  },

  GetUser: async function (uid) {
    const userRef = doc(this.db, "users", uid);
    const docSnap = await getDoc(userRef);
    if (docSnap.exists()) {
      return docSnap.data();
    } else {
      return null;
    }
  },

  Update: async function (data) {
    try {
      const userDocRef = doc(this.db, "users", data.uid);
      await updateDoc(userDocRef, { ...this.ToFirestoreUser(data) });
    } catch (e) {
    //   toast.error(AuthErrorHelper.HandleMessage(e));
    }
  },

  UpdateLastAccess: async function (uid) {
    try {
      const userDocRef = doc(this.db, "users", uid);
      await updateDoc(userDocRef, { updatedDate: Timestamp.now() });
    } catch (e) {
    //   toast.error(AuthErrorHelper.HandleMessage(e));
    }
  },

  List: async function (res) {
    const querySnapshot = await getDocs(
      collection(this.db, "users"),
      limit(1000)
    );
    const results = querySnapshot.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    }));
    res(results);
  },

  GetTotalCount: async function () {
    const coll = collection(this.db, "users");
    const snapshot = await getCountFromServer(coll);
    return snapshot.data().count;
  },

  GetTotalCountByLevel: async function (level) {
    const coll = collection(this.db, "users");
    const q = query(coll, where("level", "==", level));
    const snapshot = await getCountFromServer(q);
    return snapshot.data().count;
  },

  GetAdminReportsByDate: async function (startDate, endDate) {
    const usersQuery = query(
      collection(this.db, "users"),
      where("createdDate", ">=", Timestamp.fromDate(startDate)),
      where("createdDate", "<=", Timestamp.fromDate(endDate))
    );

    // Initialize a dictionary to hold counts for each month-year in the range
    const countsByMonth = {};

    // Generate all months between startDate and endDate
    let currentMonth = DateHelper.GetFirstDayOfMonthByDate(startDate);
    while (currentMonth <= endDate) {
      const year = currentMonth.getFullYear();
      const month = currentMonth.getMonth();
      const monthYear = `${year}-${month.toString().padStart(2, "0")}`;
      countsByMonth[monthYear] = {
        year: year,
        month: month,
        usuarios: 0,
        corretores: 0,
      };
      currentMonth = DateHelper.AddMonths(currentMonth, 1);
    }

    // Process the documents to group by month
    (await getDocs(usersQuery)).forEach((doc) => {
      const createdDate = doc.data().createdDate.toDate();
      const year = createdDate.getFullYear();
      const month = createdDate.getMonth();
      const monthYear = `${year}-${month.toString().padStart(2, "0")}`;
    });

    // Convert countsByMonth to an array of objects
    const result = Object.keys(countsByMonth).map((key) => ({
      ...countsByMonth[key],
    }));

    return result;
  },

  UpdateToken: async function () {
    try {
      const updateAccessTokenClaims = httpsCallable(this.functions, "updateAccessTokenClaims");
      const response = await updateAccessTokenClaims();
      console.log("Token claims updated successfully:", response.data);
    } catch (error) {
      console.error("Error updating token claims:", error.message);
    }
  },
};
